import EntityTypeEnum from 'common/enums/entityTypeEnum'

export const BlogRootEntityTypes = [
  EntityTypeEnum.BlogPageBody,
  EntityTypeEnum.BlogPostLayoutBody,
  EntityTypeEnum.BlogPostBody,
]
